<template>
  <b-modal
    id="residents_filter"
    size="md"
    no-close-on-backdrop
    hide-footer
    title="FILTRAR"
    @show="evOnShow"
  >
    <div class="row">
      <div class="col-md-12">
        <label>STATUS</label>
        <b-select
          :options="statuses"
          v-model="val.status"
          value-field="value"
          text-field="text"
        >
        </b-select>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
        <v-btn @click="emit" class="btn-filter" type="relief">
          <i class="fas fa-filter mr-2 text-twenty"></i>
          FILTRAR
        </v-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ResidentsFilter",

  props: {
    value: Object,
  },

  data() {
    return {
      statuses: [
        { text: "TODOS", value: "ALL" },
        { text: "ATIVO", value: "ATIVO" },
        { text: "INATIVO", value: "INATIVO" },
      ],
      val: {
        status: "ATIVO",
      },
    };
  },

  created() {
    this.emit();
  },

  methods: {
    async evOnShow() {
      this.val = { ...this.value };
    },

    async emit() {
      this.$emit("input", this.val);
      this.$bvModal.hide("residents_filter");
    },
  },
};
</script>

<style>
</style>